export default __webpack_public_path__ + "static/media/sequencium-preview.b4744e0b.png";